import { render, staticRenderFns } from "./VisitOrders.vue?vue&type=template&id=98094ed0&scoped=true"
import script from "./VisitOrders.vue?vue&type=script&lang=js"
export * from "./VisitOrders.vue?vue&type=script&lang=js"
import style0 from "./VisitOrders.vue?vue&type=style&index=0&id=98094ed0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98094ed0",
  null
  
)

export default component.exports